<template>
    <div class="adv-create wrapper">
        <div class="title">
            <div class="word">تۈر تەھرىرلەش</div>
        </div>
        <div class="form">
            <div class="row">
                <div class="col col-1">
                    <label>تۈر نامى</label>
                    <label>
                        <input class="input" type="text" placeholder="تۈر نامىنى كىرگۈزۈڭ" v-model="name" ref="title" @change="nameSetModified">
                    </label>
                </div>
                <div class="col col-1">
                    <label>ھالىتى</label>
                    <Switch :status="status" @update="updateStatus"/>
                </div>
                <div class="col col-1">
                    <label>باش بەتتە كۆرۈنەمدۇ ؟</label>
                      <Switch :status="homePageRecommendStatus" @update="updateHomePageRecommendStatus" positive-text="ھەئە" negative-text="ياق"/>
                </div>
                <div class="col col-1">
                    <label>تەرتىپى</label>
                    <label>
                        <input class="input ltr" type="number" placeholder="تۈر تەرتىبىنى كىرگۈزۈڭ، قۇرۇق قويسىڭىزمۇ بولىدۇ" v-model="sort" @change="sortSetModified">
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>
                        <span>تۈر سىنبەلگىسى</span>

                    </label>
                    <div class="upload-placeholder" @click="pickImage" v-if="imageInfo === null">
                        <i class="iconfont icon-tupian"></i>
                    </div>
                    <img class="image-viewer" @click="pickImage" :src="imageInfo.url" v-if="imageInfo != null"
                         alt="adv image">
                    <input type="file" accept="image/*" ref="imageInput" @change="imageInputAtChange">
                </div>
                 <div class="col">
                    <label>تۈر رەڭگى</label>
                    <label>
                        <input class="input ltr" type="color" v-model="color" @change="colorSetModified">
                    </label>
                </div>
                <div class="col"></div>
            </div>
            <div class="btn">
                <div class="btn-save" @click="edit">ساقلاش</div>
                <div class="btn-back" @click="toBack"> بىكار قىلىش </div>
            </div>
        </div>
    </div>
     <confirm-box
    ref="confirmBox"
    :content="confirmBoxContent"
    @confirm="cancel"
    />
    <toast ref="toast" position="center" type="danger"/>
</template>

<script>
    import Switch from "../../components/Switch";
    import Toast from "../../components/Toast";
    import ConfirmBox from "../../components/ConfirmBox";
    import {upload} from "../../api/common";
    import {getDetail, update} from "../../api/category";

    let self
    let requesting = false
    let modified = false;
    export default {
        name: "CategoryCreate",
        emits: ['showLoading'],
        components: {Toast, Switch, ConfirmBox},
        created() {
            self = this
            self.id = Number(self.$route.params.id)
            self.loadDetail()
        },
        data() {
            return {
                id: 0,
                status: true,
                imageInfo: null,
                name: '',
                sort: '',
                color: '#5867dd',
                chosenTypeIndex: 0,
                imageHelp: "رەسىم دىگەن ماندا ۋولىدا جۇما",
                orgData: null,
                confirmBoxContent:'',
                homePageRecommendStatus:false,
            }
        },
        methods: {
            nameSetModified() {
              modified = true
            },
            sortSetModified() {
              modified = true
            },
            colorSetModified() {
             modified = true
            },
            toBack() {
                if (modified) {
                  self.confirmBoxContent = "توشقۇزغان ئۇچۇرلارنى راستىنلا بىكا قىلامسىز؟";
                  self.$refs.confirmBox.show();
                 return;
                }
                self.$router.back()
            },
            cancel() {
              self.$router.back();
              modified = false
            },
            updateStatus() {
                modified = true
                self.status = !self.status
            },
            updateChosenTypeIndex(e) {
                self.chosenTypeIndex = e.chosenIndex
            },
             updateHomePageRecommendStatus() {
                modified = true
                self.homePageRecommendStatus = !self.homePageRecommendStatus
            },
            updateChosenSourceIndex(e) {
                self.chosenSourceIndex = e.chosenIndex
            },
            pickImage() {
                self.$refs.imageInput.click()
            },
            imageInputAtChange(e) {
                modified = true
                if (e.target.files.length !== 1) {
                    return
                }
                let formData = new FormData()
                formData.append('image', e.target.files[0])
                formData.append('type', 'category')
                upload(formData).then(res => self.imageInfo = res)
            },
            edit() {
                if (requesting) return;
                if (!self.validate()) return
                let data = {
                    id: self.id,
                    name: self.name,
                    sort: self.sort === '' ? 1 : Number(self.sort),
                    status: self.status ? 1 : 0,
                    recommend: self.homePageRecommendStatus ? 1 : 0,
                    color: self.color,
                    image:self.imageInfo.path
                }

                requesting = true

                update(data).then(res => {
                    self.$refs.toast.show(res, 'success')
                    setTimeout(() => {
                        self.$router.back()
                        requesting = false
                    }, 1000)
                })
            },
            validate() {
                if (self.name === '') {
                    self.$refs.toast.show('تۈر نامىنى تولدۇرۇڭ')
                    self.$refs.title.focus()
                    return false
                }

                return true;
            },
            loadDetail() {
                getDetail(self.id).then(res => {
                    self.orgData = res
                    self.fillData()
                })
            },
            fillData() {
                self.name = self.orgData.name
                self.status = self.orgData.status === 1
                self.sort = self.orgData.sort
                self.homePageRecommendStatus = self.orgData.is_recommend ===   1
                self.color = self.orgData.color
                self.imageInfo = {
                    url: self.orgData.imageUrl,
                    path: self.orgData.image,
                };
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/less/global.less";
    @import "../../assets/less/anim.less";

    .adv-create {
        direction: rtl;
        max-width: @wrap-width;
        min-width: @wrap-min-width;
        margin: @margin-size-large auto;
        border-radius: @radius-size;
        box-sizing: border-box;
        background: white;
        min-height: @wrap-min-height;
        @title-height: 60px;
        @inputHeight: 36px;

        .title {
            @btn-size: 40px;
            box-sizing: border-box;
            font-weight: bold;
            padding: 0 @margin-size;
            margin-bottom: @margin-size-large;
            border-bottom: fade(@color-nice-black, 10%) 1px solid;
            height: @title-height;
            line-height: @title-height;
            display: flex;

            .word {
                flex: 1;
            }

            .btn {
                display: flex;
                justify-content: center;
                align-items: center;

                .btn-back {
                    width: @btn-size;
                    height: @btn-size;
                    line-height: @btn-size;
                    text-align: center;
                    border-radius: @radius-size;
                    color: @color-primary;
                    cursor: pointer;
                    transform: rotate(90deg);
                    transition: background-color 200ms;

                    &:hover {
                        background: fade(@color-nice-black, 4%);
                    }
                }

                .btn-save {
                    height: @btn-size;
                    line-height: @btn-size - 4;
                    background: fade(@color-primary-dark, 6%);
                    color: @color-primary-dark;
                    cursor: pointer;
                    font-weight: normal;
                    padding: 0 @margin-size;
                    border-radius: @radius-size;
                    margin-inline-end: @margin-size;
                    transition: background-color 200ms, color 200ms;

                    &:hover {
                        background: @color-primary-dark;
                        color: white;
                    }
                }
            }
        }

        .form {
            padding: @margin-size;

            .row {
                display: flex;
                margin-bottom: @margin-size-xl;

                .col {
                    flex: 1;

                    &.col-1 {
                        flex: 1;
                    }

                    &.col-2 {
                        flex: 2;
                    }

                    &.col-3 {
                        flex: 3;
                    }

                    label {
                        display: block;
                        margin-bottom: @margin-size;
                    }

                    input.input {
                        width: 74%;
                        height: @inputHeight;
                        border-radius: @inputHeight / 2;
                        padding: 0 @margin-size;
                        border: fade(@color-primary-dark, 20%) 1px solid;
                        box-sizing: border-box;
                        margin-left: @margin-size;

                        &:focus {
                            border-color: fade(@color-primary-dark, 40%)
                        }

                        &.mn {
                            width: 30%;
                        }

                        &.sm {
                            width: 60%;
                        }

                        &.btn {
                            cursor: pointer;
                        }

                        &.ltr {
                            direction: ltr;
                        }
                    }

                    input[type=file] {
                        display: none;
                    }

                    @ph-width: 150px;
                    @ph-height: 150px;

                    .upload-placeholder {
                        width: @ph-width;
                        height: @ph-height;
                        line-height: @ph-height;
                        text-align: center;
                        box-sizing: border-box;
                        border-radius: @radius-size;
                        border: fade(@color-primary-dark, 40%) 1px dashed;
                        cursor: pointer;

                        i {
                            font-size: @font-size-xxxl;
                            color: fade(@color-primary-dark, 40%);
                        }
                    }

                    .image-viewer {
                        height: @ph-height;
                        max-width: @ph-width;
                    }
                }
            }

            .btn {
                align-items: center;
                display: flex;

                .btn-save {
                    height: 40px;
                    line-height: 40px;
                    width: 50px;
                    background: fade(@color-primary-dark, 6%);
                    color: @color-primary-dark;
                    cursor: pointer;
                    font-weight: normal;
                    padding: 0 @margin-size;
                    border-radius: @radius-size;
                    margin-inline-end: @margin-size;
                    transition: background-color 200ms, color 200ms;
                    background: @color-primary-dark;
                        color: white;

                    &:hover {
                        background: @color-primary-dark;
                        color: white;
                    }
                }

                .btn-back{
                   height: 40px;
                    line-height: 40px;
                    width: 70px;
                    background: fade(@color-accent, 6%);
                    color: @color-accent;
                    cursor: pointer;
                    font-weight: normal;
                    padding: 0 @margin-size;
                    border-radius: @radius-size;
                    margin-inline-end: @margin-size;
                    transition: background-color 200ms, color 200ms;
                     background-color: #fd397a;
                      border-color: #fd397a;
                      color: #fff;

                    &:hover {
                      background-color: #fd397a;
                      border-color: #fd397a;
                      color: #fff;
                    } 
                }
            }
        }
    }
</style>